import Vue from "vue";
import axios from "axios";

Vue.prototype.$http = axios;
axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
